import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";

export function convertListToTree(list: ServiceProcess[]) {
  const rows = JSON.parse(JSON.stringify(list)) as ServiceProcess[];

  const nodes = rows.filter(
    row => !rows.some(_row => _row.pid === row.parent_pid)
  );

  let toDo = nodes.slice();

  while (toDo.length) {
    const node = toDo.shift();

    rows.forEach(row => {
      if (row.parent_pid === node?.pid) {
        const child = row;

        if (node.children) {
          node.children = [...node.children, child];
        } else {
          node.children = [child];
        }

        toDo = [...toDo, child];
      }
    });
  }

  return nodes;
}
